// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { en } from 'vuetify/locale'

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'en',
    fallback: 'en',
    messages: { en },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2c7da0', // Main blue
          secondary: '#004617', // Dark green
          accent: '#61a5c2', // Lighter blue for accents
          error: '#d62828',
          warning: '#f77f00',
          info: '#2c7da0',
          success: '#06a77d',
          surface: '#ffffff',
          background: '#f5f7fa',
          'surface-variant': '#e8f4f8',
          'on-surface': '#013a63',
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'primary-darken-1': '#013a63', // Dark blue
          'secondary-darken-1': '#003311',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#2c7da0', // Main blue
          secondary: '#06a77d', // Lighter green for dark mode
          accent: '#61a5c2', // Lighter blue
          error: '#ff6b6b',
          warning: '#ffa94d',
          info: '#4dabf7',
          success: '#51cf66',
          surface: '#013a63', // Dark blue as surface
          background: '#001d3d',
          'surface-variant': '#014f86',
          'on-surface': '#e8f4f8',
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'primary-darken-1': '#014f86',
          'secondary-darken-1': '#004617',
        },
      },
    },
  },
})
